import React from "react";
import AccordionBtnV1 from "../UI/accordion/AccordionBtnV1";
import classes from "./SearchBarAccordion.module.css";
import FilterDishBar from "./FilterDishBar";

const SearchBarAccordion = (props) => {
  return (
    <div className={classes.container}>
      <AccordionBtnV1 title="Tìm kiếm" onClose={true}>
        <FilterDishBar onSearch={props.onSearch} loadAll={props.loadAll} />
      </AccordionBtnV1>
      {/* <AccordionBtnV1 title="Lọc theo thứ tự" onClose={true}>
        <DishOrderFilter onSelect={filterSelectHandler} />
      </AccordionBtnV1> */}
    </div>
  );
};

export default SearchBarAccordion;
